import {FC} from 'react'

const Error403: FC = () => {
  return (
    <>
      <h1 className='fw-bolder fs-4x text-gray-700 mb-10'>Quyền truy cập bị giới hạn</h1>

      <div className='fw-bold fs-3 text-gray-400 mb-15'>
        Chức năng này hiện chưa được cấp cho tài khoản của bạn<br/>
        Vui lòng liên hệ quản trị hệ thống để được hỗ trợ
      </div>
    </>
  )
}

export {Error403}
